import { RevenueReportActionTypes } from "models/actionTypes/revenueReportActionTypes";
import { ReduxConstants } from "utils/constants";

export const revenueReportApproved = (id: string | number): RevenueReportActionTypes => {
  return {
    type: ReduxConstants.RevenueReportActions.REVENUE_REPORT_APPROVED,
    payload: id,
  };
};

export const revenueReportSnoozed = (id: string | number): RevenueReportActionTypes => {
  return {
    type: ReduxConstants.RevenueReportActions.REVENUE_REPORT_SNOOZED,
    payload: id,
  };
};
